module.exports = __webpack_public_path__ + "static/media/good.34537412.gif";